module.exports = __webpack_public_path__ + "static/media/buy_req_teach_13.a2ade772.jpg";